import React from 'react'

import { HeadingMedium, Table, Label } from '@pb/components'
import { formatCurrency } from '@pb/utils'
import PropTypes from 'prop-types'

import styles from './OrderSummary.scss'
import SummaryItem, { ITEM_TYPE } from './SummaryItem'

const OrderSummary: React.FC<any> = ({
  order: {
    discounts = [],
    giftCards = [],
    shippingFees = [],
    salesTaxes = [],
    returnedAmount,
    servicingCharges = [],
    totalAmount,
    amountPaid,
    amountLeftToPay,
    createdAt,
    statusDescription,
    paymentMethod,
    dueDate,
  },
}) => (
  <Table className={styles.container}>
    <tbody>
      {discounts.map(({ total_amount }) => (
        <SummaryItem
          key={`discount${total_amount}`}
          label={<Label copyKey="order.confirmation.total.discount" />}
          value={total_amount}
          type={ITEM_TYPE.AMOUNT}
        />
      ))}
      {giftCards.map(({ total_amount }) => (
        <SummaryItem
          key={`giftCard${total_amount}`}
          label={<Label copyKey="order.confirmation.total.giftCardPrice" />}
          value={total_amount}
          type={ITEM_TYPE.AMOUNT}
        />
      ))}
      {shippingFees.map(({ total_amount }) => (
        <SummaryItem
          key={`shippingFee${total_amount}`}
          label={<Label copyKey="order.confirmation.total.delivery" />}
          value={total_amount}
          type={ITEM_TYPE.AMOUNT}
        />
      ))}
      {salesTaxes.map(({ name, total_amount }) => (
        <SummaryItem
          key={`salesTax${total_amount}`}
          label={name}
          value={total_amount}
          type={ITEM_TYPE.AMOUNT}
        />
      ))}
      {!!returnedAmount && (
        <SummaryItem
          label={<Label copyKey="omnicredit.postpurchase.returned" />}
          value={returnedAmount}
          type={ITEM_TYPE.AMOUNT}
        />
      )}
      {servicingCharges.map(({ label, amount }) => (
        <SummaryItem
          key={`servicingCharge${amount}`}
          label={label}
          value={amount}
          type={ITEM_TYPE.AMOUNT}
        />
      ))}
      <tr className={styles.total}>
        <HeadingMedium Tag="th">
          <Label copyKey="order.total" />
        </HeadingMedium>
        <HeadingMedium Tag="td" right>
          {formatCurrency(totalAmount / 100)}
        </HeadingMedium>
      </tr>
      {amountPaid >= 0 && (
        <SummaryItem
          label={<Label copyKey="omnicredit.postpurchase.paidamount" />}
          value={amountPaid}
          type={ITEM_TYPE.AMOUNT}
        />
      )}
      {amountLeftToPay >= 0 && (
        <SummaryItem
          label={<Label copyKey="omnicredit.postpurchase.amountleft" />}
          value={amountLeftToPay}
          type={ITEM_TYPE.AMOUNT}
        />
      )}
      <SummaryItem
        label={<Label copyKey="omnicredit.postpurchase.purchasedate" />}
        value={createdAt}
        type={ITEM_TYPE.DATE}
      />
      <SummaryItem
        label={<Label copyKey="omnicredit.postpurchase.purchasestatus" />}
        value={statusDescription || <Label copyKey="profile.order.status.inProgress" />}
      />
      <SummaryItem
        label={<Label copyKey="omnicredit.postpurchase.paymentmethod" />}
        value={paymentMethod}
      />
      {dueDate && (
        <SummaryItem
          label={<Label copyKey="omni.details.todo.section.purchases.section.payment.date" />}
          value={dueDate}
          type={ITEM_TYPE.DATE}
        />
      )}
    </tbody>
  </Table>
)

OrderSummary.propTypes = {
  order: PropTypes.object.isRequired,
}

export default OrderSummary
